<div class="cookie-modal">
  <div class="cookie-dialog">
    <div class="cookie-header">
      <h2>{{ 'home.accept-cookies-policies-modal.dialog.title' | translate }}</h2>
      <button mat-icon-button mat-dialog-close (click)="onClose()" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="privacy-content-wrapper">
      <mat-dialog-content class="cookie-content">
        <p>{{ 'home.accept-cookies-policies-modal.dialog.first-paragraph' | translate }}</p>
        <p>
          {{ 'home.accept-cookies-policies-modal.dialog.second-paragraph' | translate }}
          <a (click)="openPrivacyPolicy()" class="privacy-link">
            <strong>{{ 'home.accept-cookies-policies-modal.dialog.policies-link' | translate }}</strong>
          </a>
        </p>
      </mat-dialog-content>
    </div>

    <mat-divider style="border-top-color: white; border-top-width: 1px"></mat-divider>

    <mat-dialog-actions class="cookie-actions">
      <button mat-button (click)="openModalPreferences()" class="preferences-btn">
        {{ 'home.accept-cookies-policies-modal.dialog.preferences-button' | translate }}
      </button>
      <button mat-button [mat-dialog-close] (click)="onAccept()" class="accept-all-btn">
        {{ 'home.accept-cookies-policies-modal.dialog.accept-all-button' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
